import { Loader2, WifiOff } from 'lucide-react'
import { useWebSocketContext } from '@/contexts'

export default function ConnectionBanner() {
  const { connectionState } = useWebSocketContext()

  if (connectionState === 'connected') {
    return null
  }

  const isRetrying = connectionState === 'connecting' || connectionState === 'reconnecting'

  const label = isRetrying
    ? 'Reconnecting…'
    : connectionState === 'error'
      ? 'Connection lost — changes may not sync'
      : 'Disconnected — changes will not sync'

  const Icon = isRetrying ? Loader2 : WifiOff

  return (
    <div className={`flex items-center justify-center gap-2 px-4 py-1.5 text-sm font-medium ${isRetrying ? 'bg-yellow-500/15 text-yellow-600 dark:text-yellow-400' : 'bg-destructive/15 text-destructive'}`}>
      <Icon className={`h-4 w-4 ${isRetrying ? 'animate-spin' : ''}`} />
      <span>{label}</span>
    </div>
  )
}